export default {"src":"/_next/static/media/fullTimetransferGuarante.83046201.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};